// inv/src/entry-client.jsx
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { AuthProvider } from './components/authentication/AuthContext';
import { DataContext } from './components/data/DataContext';
import App from './App';
import './App.css';

const initialUser = window.__INITIAL_USER__ ?? null;
const initialData = window.__INITIAL_DATA__ ?? {};
const ssrLang = window.__INITIAL_LANG__ || initialData.lang || 'en';

(async () => {
  if (i18n.language !== ssrLang) {
    await i18n.changeLanguage(ssrLang);
  }

  hydrateRoot(
    document.getElementById('root'),
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <AuthProvider initialUser={initialUser}>
          <DataContext.Provider value={{ ...initialData, lang: ssrLang }}>
              <App />
            </DataContext.Provider>
          </AuthProvider>
        </BrowserRouter>
      </I18nextProvider>
    </React.StrictMode>,
    {
      onRecoverableError(error) {
        console.error('Recoverable React error:', error);
      },
    }
  );
})();